export enum RequestStatus {
    FULFILLED = `fulfilled`,
    PENDING = `pending`,
    REJECTED = `rejected`,
}
